import React from "react";
import { Col, Row } from "react-bootstrap";
import { useFieldArray, useFormContext } from "react-hook-form";
import { Button, Input, FieldGroup, SvgIcon } from "core/components";
import { translate } from "core/helpers";
import { DocumentFormData } from "core/schema";
import DocumentModal from "./DocumentModal";

type DocumentFieldsProps = { readOnly: boolean };

const DocumentFields = ({ readOnly }: DocumentFieldsProps): JSX.Element => {
  const fieldArrayName = "documents_attributes";
  const {
    control,
    getValues,
    formState: { errors }
  } = useFormContext();
  const { fields } = useFieldArray<DocumentFormData>({
    control,
    name: fieldArrayName,
    keyName: "key"
  });
  const [showModal, setShowModal] = React.useState(false);
  const [isView, setIsView] = React.useState(false);
  const [currentFieldIndex, setCurrentFieldIndex] = React.useState(0);

  React.useEffect(() => {}, [fields, currentFieldIndex]);

  return (
    <React.StrictMode>
      {fields.map((field, index) => {
        const documentType = translate(field.document_type);

        return (
          <Row key={field.key} className="align-items-center">
            <Col>
              <FieldGroup label={documentType} required>
                <Input
                  value={getValues(`${fieldArrayName}.[${index}].file_name`) || ""}
                  placeholder={`No ${documentType}`}
                  readOnly={true}
                  errorMessage={
                    errors?.documents_attributes?.message
                      ? !getValues(`${fieldArrayName}.[${index}].file_name`) && `${documentType} is ${errors?.documents_attributes?.message}`
                      : null
                  }
                />
              </FieldGroup>
            </Col>
            <Col sm="auto" className="text-right-lg">
              {!readOnly && (
                <Button
                  icon="upload"
                  className="a button button--action button--action-warning"
                  onClick={() => {
                    setCurrentFieldIndex(index);
                    setShowModal(!showModal);
                    setIsView(false);
                  }}
                />
              )}
              {(field.file_url || field?.file_name) && (
                <>
                  <Button
                    icon="view"
                    className="a button button--action button--action-success"
                    onClick={() => {
                      setCurrentFieldIndex(index);
                      setShowModal(!showModal);
                      setIsView(!isView);
                    }}
                  />
                  <a
                    className="a button button--action button--action-info"
                    download={true}
                    target="_blank"
                    rel="noopener"
                    href={field.file_url || field?.file_name}
                  >
                    <SvgIcon name="download" />
                  </a>
                </>
              )}
            </Col>
          </Row>
        );
      })}
      <DocumentModal
        index={currentFieldIndex}
        readOnly={readOnly}
        show={showModal}
        isView={isView}
        onClose={() => {
          setShowModal(false);
          setIsView(false);
        }}
        onConfirm={() => {
          setShowModal(false);
          setIsView(false);
        }}
      />
    </React.StrictMode>
  );
};

export default DocumentFields;
